import { CzechDocumentType } from './CzechDocumentType';

export const healthInsuranceExemptingDocuments = [
  CzechDocumentType.PotvrzeniOStudiu,
  CzechDocumentType.VymerStarobnihoDuchodu,
  CzechDocumentType.VymerMaterskeRodicovskeDovolene,
  CzechDocumentType.PotvrzeniJinehoZamestnavateleOOdvoduZdravotnihoPojisteni,
  CzechDocumentType.PotvrzeniOPeciODite,
  CzechDocumentType.VymerInvalidnihoDuchodu12Stupne,
  CzechDocumentType.VymerInvalidnihoDuchodu1Stupne,
  CzechDocumentType.VymerInvalidnihoDuchodu2Stupne,
  CzechDocumentType.VymerInvalidnihoDuchodu3Stupne,
  CzechDocumentType.PrukazZTPP,
];
